import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";
import { cancelAccount } from "../settings/settingsSlice";
import Form from 'react-bootstrap/Form'
import { Button, Modal } from "react-bootstrap"
import { Link } from "react-router-dom"
import { Spinner } from "react-bootstrap"
import Select from 'react-select'
import {envAwarePost} from '../../util/util'

function CancelAccount({ showCancelAccount, setShowCancelAccount, setTriggerReload }) {
    const dispatch = useDispatch();
    const [cancelReason, setCancelReason] = useState("");
    const [message, setMessage] = useState("");
    const [loadingCancel, setLoadingCancel] = useState(false);
    const [subscriptionCanceled, setSubscriptionCanceled] = useState(false);
    const [userDeleted, setUserDeleted] = useState(false);

    const [activeTab,setActiveTab] = useState('offer')
    
    useEffect(() => {
        setMessage("");
        setCancelReason("");
        setUserDeleted(false);
        setSubscriptionCanceled(false);
    }, [showCancelAccount])

    function handleCancelAccount() {
        let confirm = window.confirm('Are you sure you want to cancel your account and remove all of your data? Removing your data CANNOT be undone.');
        if (confirm == false) {
            return;
        }
        setLoadingCancel(true);
        dispatch(cancelAccount({ reason: `${reason} - ${cancelReason}` }))
            .then(res => {
                setLoadingCancel(false);
                var dataObj = res.payload;
                if (dataObj.success == "0") {
                    alert("An error occured, please try again or contact support@fitsw.com for help")
                }
                else if (dataObj.success == "1") {
                    setMessage(dataObj.message);
                    if (dataObj.action == "subscription_cancelled"){
                        setSubscriptionCanceled(true);
                    } else if (dataObj.action == "deleted") {
                        setUserDeleted(true);
                    }
                }
            })
    }

    const [applyingDiscount,setApplyingDiscount] = useState(false)
    const handleDiscount = ()=>{
        setApplyingDiscount(true)
        envAwarePost('api/purchases/',{
            action:'applyCouponToSubscription',
            coupon_key:'cancellation_promo'
        }).then(res=>{
            setApplyingDiscount(false)
            if (res.success==='1') {
                setActiveTab('schedule')
            }else{
                window.alert(res.message)
            }
        })
    }

    const [reason,setReason] = useState("")
    const [followUp,setFollowUp] = useState('')


    const handleClose = () => { 
        setShowCancelAccount(false) 
        setActiveTab('offer')
    };

    const reasons = [
        {
            label:'Too complicated to use',
            value:'Too complicated to use',
            followUp:'Is there anything we can do to make things more straightforward?'
        },{
            label:'Unable to find any clients',
            value:'Unable to find any clients',
            followUp:'Are you offering online or in person training? Is there anything we can do to help you find clients?'
        },{
            label:'App was too buggy',
            value:'App was too buggy',
            followUp:'What feature did you find buggy? We will work to fix right away.'
        },{
            label:'Not a personal trainer anymore',
            value:'Not a personal trainer anymore',
            followUp:'Why did you stop? Is there anything we could do to help?'
        },{
            label:'Building workouts was too complicated',
            value:'Building workouts was too complicated',
            followUp:'What made the workout builder hard to use?'
        },{
            label:'Clients are not using it',
            value:'Clients are not using it',
            followUp:'Is there anything we can do to make the app more useful to your clients?'
        },{
            label:'Temporary. I\'ll be back.',
            value:'Temporary. I\'ll be back.',
            followUp:'Why are you stopping temporarily?'
        },{
            label:'Found a better product',
            value:'Found a better product',
            followUp:'List product you are switching to'
        },{
            label:'Needs better nutrition monitoring',
            value:'Needs better nutrition monitoring',
            followUp:'What other nutrition capabilities do you need?'
        },{
            label:'No longer training online',
            value:'No longer training online',
            followUp:'How can we improve the app to fit into your offline training?'
        },{
            label:'Did not know how to sell online training',
            value:'Did not know how to sell online training',
            followUp:'How can we simplify and improve the process of online training for you?'
        },{
            label:'Other',
            value:'Other',
            followUp:'Please tells us why you would like to cancel your account'
        }
    ]

    return (
        <>
            <Modal
                show={showCancelAccount}
                onHide={handleClose}
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Cancel Account</Modal.Title>
                </Modal.Header>
                {activeTab==='offer'&&
                    <Modal.Body>
                        <div style={{
                            fontSize:'18px',
                            marginBottom:'32px'
                        }}>
                            Hey, don't go!
                            <br/>
                            We'll give you <strong>40% off for 3 months</strong> and a <strong>free one-on-one with our product experts</strong> to help you get setup. 
                        </div>
                        <Button 
                            disabled={applyingDiscount}
                            onClick={handleDiscount} 
                            variant="outline-success" 
                            block
                        >
                            Apply discount and schedule meeting {applyingDiscount&&<Spinner animation="border" size="sm"/>}
                        </Button>
                        <Button 
                            disabled={applyingDiscount}
                            onClick={setActiveTab.bind(null,'cancel')}
                            variant="outline-danger" 
                            block
                        >
                            I still want to cancel
                        </Button>
                    </Modal.Body>
                }
                {activeTab==='schedule'&&
                    <Modal.Body>
                        <Button
                            variant="outline-primary"
                            target="_blank"
                            href="https://calendly.com/nate-8v8/zoom-meeting"
                            block
                        >
                            Schedule Meeting with Product Expert
                        </Button>
                    </Modal.Body>
                }
                {activeTab==='cancel'&&
                    <>
                        <Modal.Body>
                            {message ? message :
                                <>
                                    <p>Thank you for your business. If you are sure you would like to cancel, click "Cancel Account".
                                        We will remove your account and all of your data. Removing your data CANNOT be undone. </p >

                                    <p> We would appreciate some quick feedback on your reason for cancelling and how we can improve.</p>
                                    <p><strong>Reason for Cancelling</strong></p>
                                    <Select 
                                        onChange={selected=>{
                                            setReason(selected.value)
                                            setFollowUp(selected.followUp)
                                        }}
                                        placeholder="Choose Reason"
                                        options={reasons}
                                    />
                                    {Boolean(followUp)&&
                                        <>
                                            <p className="mt-2"><strong>{followUp}</strong></p>
                                            <textarea 
                                                className="form-control" 
                                                rows="2" 
                                                value={cancelReason} 
                                                onChange={(e) => setCancelReason(e.target.value)} 
                                                placeholder=""
                                            />
                                        </>
                                    }
                                </>}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button 
                                onClick={handleDiscount} 
                                variant="outline-success" 
                                block
                                disabled={applyingDiscount}
                            >
                                Last Chance: Get 40% off for 3 months & Schedule Meeting  {applyingDiscount&&<Spinner animation="border" size="sm"/>}
                            </Button>
                            <div className="d-flex align-items-start">
                                <Button
                                    disabled={applyingDiscount}
                                    className="mr-2"
                                    variant="secondary" onClick={()=>{ 
                                    if (userDeleted) {
                                        window.location.reload();
                                    } else if (subscriptionCanceled) {
                                        setTriggerReload(true);
                                        handleClose();
                                    } else {
                                        handleClose();
                                    }}}>
                                    Close
                                </Button>
                                {!userDeleted && 
                                    <div>
                                        <Button  
                                            disabled={applyingDiscount}
                                            disabled={!Boolean(cancelReason)||!Boolean(reason)} 
                                            className="btn-danger" 
                                            type="button" 
                                            name="cancelAccount" 
                                            onClick={
                                                () => {!loadingCancel && handleCancelAccount()
                                            }
                                        }>
                                            {loadingCancel 
                                                ? <Spinner animation="border" variant="white" size="sm" /> 
                                                : subscriptionCanceled ? "Remove All Data" : "Cancel Account"
                                            }
                                        </Button>
                                        {!Boolean(cancelReason)&&
                                            <div className="text-right text-danger">
                                                <small>Please provide a reason</small>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </Modal.Footer>
                    </>
                }
            </Modal>
        </>
    );
}



export default CancelAccount;